import Index from '../components/Configuration/Index'

let routes = {
    path: '/configuration',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/configuration',
            component: Index
        },
    ]
}


export default routes


// WEBPACK FOOTER //
// ./src/router/configuration.js